export function scrollToLandingSection(id, navigate) {
  const path = window.location.pathname
  const stayOnPlanes = id === 'planes' && path === '/planes'
  const stayOnBandas = path === '/bandas'
  if (stayOnBandas || stayOnPlanes) {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
    return
  }
  navigate(id === 'planes' ? '/planes' : '/bandas')
  setTimeout(() => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
  }, 300)
}
